<template>
  <div>
    <md-button
      v-if="canAddFamily"
      :disabled="loading"
      @click="prepareCreate"
      class="floating md-info md-just-icon md-round"
    >
      <md-icon>add</md-icon>
    </md-button>
    <md-toolbar class="md-info" md-elevation="1">
      <div class="md-layout">
        <div class="md-layout-item md-size-40">
          <h3 class="md-title">Familia</h3>
        </div>
        <div class="md-layout-item md-size-60">
          <md-field md-inline>
            <label>Buscar</label>
            <md-input class="sizeBox" v-model="searchQuery"></md-input>
          </md-field>
        </div>
      </div>
    </md-toolbar>
    <md-list class="md-triple-line">
      <md-content v-show="!loading" class="md-scrollbar">
        <div v-for="(fam, i) in queriedData" :key="fam.id">
          <md-divider class="md-inset"></md-divider>
          <md-list-item
            @mouseover="showIcons(i)"
            @click="filterItem(fam, i)"
            :class="clickedFamily === fam ? 'selected-family' : ''"
          >
            <div class="md-list-item-text">
              <span>{{ fam.name }}</span>
              <span>
                <strong>ID</strong>
                {{ fam.id }}
              </span>
              <p>
                <strong>Codigo</strong>
                {{ fam.codename }}
              </p>
            </div>
            <div v-if="currentlyShow === i">
              <md-button
                v-if="canChangeFamily"
                class="md-primary md-just-icon md-round edit"
                @click="prepareEdit(fam)"
              >
                <md-icon>edit</md-icon>
              </md-button>
              <md-button
                v-if="canDeleteFamily"
                class="md-primary md-just-icon md-round edit"
                @click="deleteItem(fam)"
              >
                <md-icon>delete</md-icon>
              </md-button>
            </div>
          </md-list-item>
        </div>
      </md-content>
    </md-list>
    <editModal
      v-if="classicModal"
      :editedItem="item"
      :isRegister="isRegister"
      :loading.sync="loadingFamilies"
      @saved="updateElement"
      @close="classicModalHide"
      @error="classicModalHide"
    ></editModal>
  </div>
</template>
<script>
import dataService from "@/services/catalog";
import { mapState } from "vuex";
import editModal from "./createFamily";
import Fuse from "fuse.js";

import mapPermissions from "@/plugins/accountPermissions/mapPermissions";

export default {
  props: {
    loading: {
      type: Boolean,
    },
  },
  components: {
    editModal,
  },
  data() {
    return {
      item: {},
      search: "",
      classicModal: false,
      hover: false,
      currentlyShow: null,
      itemTemplate: {
        id: "01",
        code: "DP",
        name: "Dispositivos de Protección",
      },
      fuseSearch: null,
      propsToSearch: ["name", "codename"],
      searchQuery: "",
      searchedData: [],
      clickedFamily: null,
      loadingFamilies: false,
    };
  },
  computed: {
    ...mapPermissions("Services", "family"),
    ...mapState("catalogs", {
      families: (s) => s["services/families"],
    }),

    queriedData() {
      let result = this.families;
      if (this.searchedData && this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result;
    },
  },
  methods: {
    filterItem(item) {
      this.clickedFamily = item;
      this.$emit("family", item.id);
    },
    showIcons(index) {
      this.hover = true;
      this.currentlyShow = index;
    },
    prepareCreate() {
      this.isRegister = true;
      this.item = {};
      this.classicModal = true;
    },

    prepareEdit(c) {
      // get element selected from table
      this.item = c; // make copy of element selected
      this.isRegister = false; // Modal in mode edition
      this.classicModal = true; // show modal
    },

    classicModalHide() {
      this.classicModal = false;
    },
    deleteItem(c) {
      this.$confirmMessage({ title: "¿Estas seguro?" }, () => {
        return dataService
          .delete("services/families", c, { useStore: true })
          .then(() => this.$successMessage({ title: "Borrado" }))
          .catch(this.$fireErrorResponse);
      });
    },

    updateElement({ original, updated }) {
      this.classicModalHide();
      if (!original.id) {
        this.createdE(updated);
      } else {
        this.editElement(updated, original);
      }
    },

    createdE(h) {
      dataService
        .create("services/families", h, { useStore: true })
        .then((item) =>
          this.$successMessage({
            title: `Creando Familia de Insumos: ${item.name}`,
          })
        )
        .catch(this.$fireErrorResponse)
        .finally(() => (this.loadingFamilies = false));
    },

    editElement(updated, original) {
      dataService
        .update("services/families", updated, original, { useStore: true })
        .then(
          (h) => this.$successMessage({ title: `${h.name} fue Editado` }),
          this.$fireErrorResponse
        );
    },
  },

  mounted() {
    dataService
      .fetch("services/families", { useStore: true })
      .then(() => {})
      .catch(this.$fireErrorResponse);

    this.fuseSearch = new Fuse(this.subFamilies, {
      threshold: 0.3,
      keys: this.propsToSearch,
    });
  },

  watch: {
    families(newList) {
      this.fuseSearch.list = newList;
    },

    searchQuery(value) {
      let result;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    },
  },
};
</script>

<style scoped lang="scss">
@import "~vue-material/dist/theme/engine"; // Import the theme engine
.floating {
  width: 40px !important;
  height: 40px !important;
  position: absolute;
  top: 78px;
  left: 8px;
  z-index: 2;
}

.md-content {
  max-height: 70vh;
  overflow: auto;
}
.sizeBox {
  max-width: 100%;
  min-width: 100%;
}
.md-button.md-fab,
.md-button.md-just-icon {
  z-index: 4;
}

.selected-family {
  background-color: md-get-palette-color(cyan, 100);
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/ListFamily.vue